(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_new"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn_bundle_slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-regimen-slider')) {
    customElements.define('bundle-regimen-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bundle-regimen__track');
        this.controls = this.querySelector('.bundle-regimen__controls');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelectorAll('[data-bundle-form]').forEach((form) => this.configureVariants(form));
        this.addEventListener('submit', (event) => this.addBundle(event), options);
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-direction]');
          const card = this.track.querySelector('li');
          if (!button || !card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: step * Number(button.dataset.direction) * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.track.addEventListener('scroll', () => this.updateControls(), options);
        this.addEventListener('shopify:block:select', (event) => {
          event.target.closest('.bundle-regimen__card')?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }, options);
        this.observer = new ResizeObserver(() => this.updateControls());
        this.observer.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.abort.abort();
        this.observer.disconnect();
      }
      updateControls() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.controls.querySelector('[data-direction="-1"]').disabled = position < 2;
        this.controls.querySelector('[data-direction="1"]').disabled = position >= max - 2;
      }
      parseVariants(text) {
        const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
        if (!lines.length) throw new Error(this.dataset.invalid);
        const ids = lines.map((line) => {
          let id = line;
          if (!/^\d+$/.test(id)) {
            const url = new URL(line, window.location.origin);
            if (!['http:', 'https:'].includes(url.protocol) || !url.pathname.includes('/products/')) throw new Error(this.dataset.invalid);
            id = url.searchParams.get('variant');
          }
          if (!/^\d+$/.test(id || '') || !Number.isSafeInteger(Number(id)) || Number(id) <= 0) throw new Error(this.dataset.invalid);
          return String(Number(id));
        });
        return [...new Set(ids)];
      }
      configureVariants(form) {
        const config = form.querySelector('[data-variant-list]');
        if (!config) return;
        const button = form.querySelector('button');
        const status = form.querySelector('[role="status"]');
        form.querySelectorAll('[data-configured-variant]').forEach((input) => input.remove());
        try {
          const ids = this.parseVariants(config.content.textContent);
          ids.forEach((id, index) => {
            for (const [key, value] of [['id', id], ['quantity', '1']]) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = `items[${index}][${key}]`;
              input.value = value;
              input.dataset.configuredVariant = '';
              form.append(input);
            }
          });
          button.disabled = false;
          status.textContent = '';
        } catch {
          button.disabled = true;
          status.textContent = this.dataset.invalid;
        }
      }
      async addBundle(event) {
        const form = event.target.closest('[data-bundle-form]');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled || this.busy) return;
        const items = Array.from(form.querySelectorAll('input[name$="[id]"]'), (input) => ({ id: Number(input.value), quantity: 1 }));
        const status = form.querySelector('[role="status"]');
        if (!items.length || items.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const label = button.textContent;
        button.textContent = this.dataset.loading;
        status.textContent = '';
        let added = false;
        try {
          const drawer = document.querySelector('cart-drawer');
          const canRender = drawer && typeof drawer.renderContents === 'function';
          const body = { items };
          if (canRender) {
            body.sections = drawer.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            drawer.setActiveElement(button);
          }
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin', body: JSON.stringify(body)
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          added = true;
          status.textContent = this.dataset.success;
          if (!canRender || body.sections.some((id) => !data.sections?.[id])) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-regimen-slider', cartData: data })).catch(() => {});
          }
        } catch (error) {
          if (added) window.location.assign(this.dataset.cartUrl);
          else status.textContent = error.message || this.dataset.error;
        } finally {
          this.busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
